// Sdílené styly a pomocné funkce pro obrazovky tiketů (mobile-first: prvky min. 44 px, písmo 16 px).
import { useEffect, useState } from 'react';

export const ZELENA = '#3ab54a';
export const TEXT = '#333333';

export const card = { background: '#fff', borderRadius: '10px', padding: '16px', marginBottom: '14px', border: '1px solid #e5e7eb' };
export const inputStyle = {
  display: 'block', width: '100%', boxSizing: 'border-box', padding: '12px', fontSize: '16px',
  borderRadius: '8px', border: '1px solid #9ca3af', background: '#fff', color: TEXT, minHeight: '46px',
};
// Select vypadá a měří stejně jako ostatní pole (nativní vzhled, zvlášť v Safari, ignoruje padding a výšku).
const SIPKA = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";
export const selectStyle = {
  ...inputStyle, appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none',
  backgroundImage: SIPKA, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center', backgroundSize: '12px 8px',
  paddingRight: '34px', textOverflow: 'ellipsis',
};
export const labelStyle = { display: 'block', fontSize: '13px', color: '#6b7280', margin: '12px 0 4px' };
export const btnPrimary = {
  padding: '13px 20px', fontSize: '16px', fontWeight: 'bold', background: ZELENA, color: '#fff',
  border: 'none', borderRadius: '8px', cursor: 'pointer', minHeight: '48px',
};
export const btnOutline = {
  padding: '12px 18px', fontSize: '15px', background: 'transparent', color: '#555',
  border: '1px solid #9ca3af', borderRadius: '8px', cursor: 'pointer', minHeight: '46px',
};
export const btnDanger = { ...btnPrimary, background: '#ef4444' };
export const chyboveHlaseni = { color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', padding: '10px 12px', fontSize: '14px', margin: '10px 0' };

// Text chyby z odpovědi API (FastAPI: detail je řetězec, objekt se "zprava" nebo seznam validačních chyb).
export function apiChyba(e, vychozi = 'Nepodařilo se uložit.') {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? vychozi : 'Server není dostupný.';
  if (typeof d === 'string') return d;
  if (d.zprava) return d.zprava;
  if (Array.isArray(d)) return d.map(x => String(x.msg || '').replace(/^Value error, /, '')).filter(Boolean).join(' ') || vychozi;
  return vychozi;
}

const pad = n => String(n).padStart(2, '0');

// Date -> hodnota pro DateTimeInput 'YYYY-MM-DDTHH:mm' (místní čas)
export function naLocalInput(d = new Date()) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
// den (YYYY-MM-DD) v pražském čase pro ISO čas nebo místní hodnotu DateTimeInput; backend páruje výjezdy podle pražského dne
export function prazskyDen(v) {
  if (!v) return '';
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Prague' }).format(new Date(v));
}
// místní hodnota 'YYYY-MM-DDTHH:mm' (DateTimeInput) -> ISO s časovou zónou
export function zLocalInput(v) {
  return v ? new Date(v).toISOString() : null;
}

export function formatMin(min) {
  if (min === null || min === undefined) return '—';
  const h = Math.floor(min / 60), m = min % 60;
  if (!h) return `${m} min`;
  return m ? `${h} h ${m} min` : `${h} h`;
}

export function formatDatCas(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatHodiny(h) {
  if (h === null || h === undefined) return '—';
  const abs = Math.abs(h);
  const cele = Math.floor(abs), min = Math.round((abs - cele) * 60);
  return `${h < 0 ? '−' : ''}${cele} h ${pad(min)} min`;
}

// možnosti výběru času: od `od` do `do` po `krok` minutách
export function moznostiMin(od, do_, krok) {
  const out = [];
  for (let m = od; m <= do_; m += krok) out.push(m);
  return out;
}

export function useSirka() {
  const [w, setW] = useState(window.innerWidth);
  useEffect(() => {
    const f = () => setW(window.innerWidth);
    window.addEventListener('resize', f);
    return () => window.removeEventListener('resize', f);
  }, []);
  return w;
}

// Otevře PDF z API (vyžaduje Authorization, proto přes axios + blob) v nové záložce.
// Okno se otevře hned po kliknutí (jinak ho mobilní prohlížeče blokují) a po načtení se do něj PDF vloží.
export async function otevriPdf(axios, url, params) {
  const okno = window.open('', '_blank');
  try {
    const r = await axios.get(url, { params, responseType: 'blob' });
    const adresa = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    if (okno) okno.location.href = adresa; else window.location.href = adresa;
    setTimeout(() => URL.revokeObjectURL(adresa), 5 * 60 * 1000);
  } catch (e) {
    if (okno) okno.close();
    let zprava = 'PDF se nepodařilo otevřít.';
    try { zprava = JSON.parse(await e.response.data.text()).detail || zprava; } catch { /* ponechat výchozí */ }
    throw new Error(typeof zprava === 'string' ? zprava : 'PDF se nepodařilo otevřít.');
  }
}
